"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteScrollPagination = void 0;
var AbstractPagination_1 = require("./AbstractPagination");
var ApiEndpoints_1 = require("../../Configurations/ApiEndpoints");
var dom_interact_1 = require("../../helpers/dom-interact");
var handle_url_1 = require("../../helpers/handle-url");
var HttpRequest_1 = require("../../Modules/HttpRequest");
var InfiniteScrollPagination = /** @class */ (function (_super) {
    __extends(InfiniteScrollPagination, _super);
    function InfiniteScrollPagination(el, nextPage, category, loadingMessage) {
        var _this = _super.call(this, el, nextPage, category) || this;
        _this.events = [];
        _this.url = ApiEndpoints_1.ApiEndpoints.SEARCH_MORE;
        _this.GAP = 200;
        _this.loadingMessage = loadingMessage;
        window.addEventListener('scroll', function () { return _this.onScroll(); });
        if (_this.canRequestNextPage()) {
            _this.showLoading();
            _this.sendRequest()
                .then(function (response) { return _this.handleResponse(response); })
                .catch(function (xhrResponse) {
                return HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'InfiniteScrollPagination on sendRequest in constructor');
            });
        }
        return _this;
    }
    InfiniteScrollPagination.prototype.updatePaginationState = function (response) {
        this.nextPage = response.nextPage || null;
        this.hideLoading();
        // the same here
        this.el = (0, dom_interact_1.getHTMLElement)(document, '.infinity-scroll');
    };
    InfiniteScrollPagination.prototype.canRequestNextPage = function () {
        return this.nextPage !== null && (0, dom_interact_1.isPartiallyInViewport)(this.el, this.GAP) && !this.isLoadingNextPage;
    };
    InfiniteScrollPagination.prototype.onScroll = function () {
        var _this = this;
        if (this.canRequestNextPage()) {
            var urlParameters = (0, handle_url_1.getUrlParams)();
            urlParameters.page = this.nextPage;
            (0, handle_url_1.setUrl)((0, handle_url_1.objectToParams)(urlParameters));
            this.showLoading();
            this.sendRequest()
                .then(function (response) { return _this.handleResponse(response); })
                .catch(function (xhrResponse) {
                return HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'InfiniteScrollPagination on sendRequest onScroll');
            });
        }
    };
    InfiniteScrollPagination.prototype.handleResponse = function (response) {
        if (response && response.data) {
            this.updatePaginationState(response);
            this.isLoadingNextPage = false;
            this.dispatchEvent(new CustomEvent('products:loaded'), response);
        }
    };
    InfiniteScrollPagination.prototype.showLoading = function () {
        this.loadingMessage.classList.remove('hide');
    };
    InfiniteScrollPagination.prototype.hideLoading = function () {
        this.loadingMessage.classList.add('hide');
    };
    return InfiniteScrollPagination;
}(AbstractPagination_1.AbstractPagination));
exports.InfiniteScrollPagination = InfiniteScrollPagination;
